import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M3.05395 18.984C3.05395 19.974 3.91708 21 4.90609 21H19.2917C20.2807 21 21 20.082 21 18.984C21 18.633 20.973 7.824 20.973 7.239C20.973 5.367 20.7213 4.8 17.3766 4.8V3H15.5784V4.8H8.39461V3H6.5964V4.8H4.7982C3.80919 4.8 3 5.61 3 6.6L3.05395 18.984ZM19.1838 18.3C19.1838 18.795 18.7792 19.2 18.2847 19.2H5.6973C5.2028 19.2 4.7982 18.795 4.7982 18.3V12H19.1838V18.3ZM19.1838 10.2H4.7982V7.473C4.7982 6.987 5.18482 6.6 5.67033 6.6H6.5964V8.4H8.39461V6.6H15.5874V8.4H17.3856V6.6H18.2847C18.7792 6.6 19.1838 7.005 19.1838 7.5V10.2Z' />
        </SvgIcon>
    );
});
